import './index.less';

// style dependencies
import '../../breadcrumb/style';
import '../../avatar/style';